// extracted by mini-css-extract-plugin
export default {"title":"UserEvents_title__PaOXs","event":"UserEvents_event__f-DP7"};